import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '../../../molecules/FormControl';

const getGuest = (occupant, occupantIndex) => {
  const nameTokens = occupant.name.replace(/\s+/g, ' ').split(' ');
  return {
    // Fields that cannot be changed
    age: occupant.age,
    ptype: occupant.ptype,
    code: occupant.code,

    // Fields that identify the guest
    guestIndex: occupantIndex,

    // Editable fields
    name: nameTokens.shift(),
    surname: nameTokens.shift(),
    surname2: nameTokens.join(' '),
  };
};
const guestJoinName = (guest) => {
  const tokens = [guest.name || '', guest.surname || '', guest.surname2 || ''];
  return tokens.join(' ').trim();
};

const roomGuest = ({
  guest, guestIndex, isReadOnly, guestUpdate, hasError, roomIndex,
}, context) => {
  const [error, setError] = useState({});
  const [currentGuest, setCurrentGuest] = useState(getGuest(guest, guestIndex));
  const newValueUpdate = (ev, key) => {
    const updateGuest = { ...currentGuest, [key]: ev };
    setCurrentGuest(updateGuest);
    guestUpdate({
      age: parseInt(updateGuest.age, 10),
      code: updateGuest.code,
      name: guestJoinName(updateGuest) || guest.name,
      ptype: updateGuest.ptype,
    });
  };
  const handleErrors = (ev, key) => {
    setError({ ...error, [key]: ev });
    hasError({ ...error, [key]: ev });
  };
  const getInputId = (id) => `${id}_room${roomIndex}_guest${guestIndex}`;
  return (
    <div className="px-2 py-2 w-1/2" key={guestIndex}>
      <div className="shadow-lg p-2 ">
        <div className="text-gray-500 text-sm flex justify-between w-full pb-2">
          {context.t('Guest {n}', { n: guestIndex + 1 })} <small className="text-xxs font-light">{currentGuest.code}</small>
        </div>
        <FormControl
          label={context.t('Name')}
          id={getInputId('name')}
          value={currentGuest.name}
          readOnly={isReadOnly}
          updateValue={(ev) => newValueUpdate(ev, 'name')}
          hasError={(ev) => handleErrors(ev, 'name')}
          required
        />
        <FormControl
          label={context.t('Last name')}
          id={getInputId('surname')}
          value={currentGuest.surname}
          readOnly={isReadOnly}
          updateValue={(ev) => newValueUpdate(ev, 'surname')}
          hasError={(ev) => handleErrors(ev, 'surname')}
        />
        <FormControl
          label={context.t('Second last name')}
          id={getInputId('surname2')}
          value={currentGuest.surname2}
          readOnly={isReadOnly}
          updateValue={(ev) => newValueUpdate(ev, 'surname2')}
          hasError={(ev) => handleErrors(ev, 'surname2')}
        />
        <FormControl
          label={context.t('Age')}
          id={getInputId('age')}
          type="number"
          min={0}
          max={100}
          value={currentGuest.age}
          readOnly={isReadOnly}
          updateValue={(ev) => newValueUpdate(ev, 'age')}
          hasError={(ev) => handleErrors(ev, 'age')}
        />
      </div>
    </div>
  );
};

roomGuest.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default roomGuest;
